/* eslint-disable */
import { makeStyles } from '@rentacenter/racstrap';
import React, { useContext } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { appConfig } from '../../config/app-config';
import { MicroFrontend } from './MicroFrontEnd';
import { ContainerContext } from '../../app/authenticated/Authenticated';

export const promotionTestId = 'promotionTestId';

const useStyles = makeStyles(() => ({
  microAppContainer: {
    paddingTop: '3rem',
  },
}));

export const Promotion = ({ history }: RouteComponentProps) => {
  const containerData = useContext(ContainerContext);
  const classes = useStyles();
  return (
    <div data-testid={promotionTestId} className={classes.microAppContainer}>
      <MicroFrontend
        config={appConfig.microfrontends.promotion}
        history={history}
        customProps={containerData}
      />
    </div>
  );
};
